import {Component, Input, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {AppState} from '../../reducers';
import {Store} from '@ngrx/store';
import {LogoutUser} from '../../auth/login/actions/login.actions';
import {Menu} from 'primeng/menu';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-user-login-section',
  templateUrl: './user-login-section.component.html',
  styleUrls: ['./user-login-section.component.scss']
})
export class UserLoginSectionComponent implements OnInit, OnDestroy {

  @Input() user: any;
  items: MenuItem[];
  @ViewChild('userMenu') userMenu: Menu;

  showCarsItem = false;
  private langSub: Subscription;

  constructor(private store: Store<AppState>, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.buildMenu();
    this.langSub = this.translate.onLangChange.subscribe(() => this.buildMenu());
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private buildMenu(): void {
    this.items = [
      {
        label: this.translate.instant('USER_MENU.MY_ORDERS'), items: [
          {label: this.translate.instant('USER_MENU.OPEN_ORDER'), routerLink: '/account/basic-order'},
          {label: this.translate.instant('USER_MENU.NEW_ORDER'), routerLink: '/account/calculate'},
          {label: this.translate.instant('USER_MENU.CLIENT_FILE'), routerLink: '/account/orders'},
        ]
      },
      {
        label: this.translate.instant('USER_MENU.MY_ACCOUNT'), items: [
          {label: this.translate.instant('USER_MENU.HOME'), routerLink: '/account'},
          {label: this.translate.instant('USER_MENU.SUBSCRIPTION'), routerLink: '/account/subscription'},
          ...(this.user.role.includes('commercial_importer') ? [{label: this.translate.instant('USER_MENU.AVAILABLE_VEHICLES'), routerLink: '/cars'}] : []),
          ...([{label: this.translate.instant('USER_MENU.MY_VEHICLES'), routerLink: '/cars/my-list'}]),
          {
            label: this.translate.instant('USER_MENU.LOGOUT'), command: () => {
              this.store.dispatch(LogoutUser());
            }
          },
        ]
      },
    ];
  }
}
